import { getValidationResult } from './index';

const TEAM = {
	TITLE_MIN_LENGTH: 3,
	TITLE_MAX_LENGTH: 50
};

const ERROR_MESSAGES = {
	TEAM: {
		TITLE: `عنوان تیم باید بیشتر از ${TEAM.TITLE_MIN_LENGTH} و کمتر از ${TEAM.TITLE_MAX_LENGTH} کاراکتر باشد`,
		TITLE_REQUIRED: 'نام تیم اجباری می باشد'
	}
};

export const validateTitle = ({ Title }) => {
	if (!Title) {
		return getValidationResult(false, ERROR_MESSAGES.TEAM.TITLE_REQUIRED);
	}

	const isValid = Title.length >= TEAM.TITLE_MIN_LENGTH && Title.length <= TEAM.TITLE_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.TEAM.TITLE);
};
